import { FC, useContext } from 'react';
import { BoardContext, CardContext, TableContext, TeamContext } from '../../../context';
import { Phase } from '../../../util/enums';

import { RenderStrengthCardType } from './subStrengthCardsHolderComponents';

interface IStrengthCardsHolder {
    zIndexPerPhase?: number
}

const StrengthCardsHolder: FC<IStrengthCardsHolder> = ({ zIndexPerPhase }) => {
    const { game } = useContext(TeamContext);
    const { isDragging } = useContext(CardContext);
    const { strengthCardsAnimationDuringAvatarRotation } = useContext(TableContext);
    const { instructionTutorial } = useContext(BoardContext);

    const strengthContainerOpenCloseAnimation: string = isDragging && game?.phase === Phase.CHOOSE_SOLUTION ? "board_strength_cards_holder_open" : "";
    const strengthCardsAnimationDuringAvatarRotationStyle = strengthCardsAnimationDuringAvatarRotation ? "strength_cards_animation_during_avatars_rotating" : "";
    
    const getZIndexStrengthCardsHolder = () => {
        if ( instructionTutorial === "leftSideOfTheScreen" ) return 23;
        return zIndexPerPhase;
    }

    return (
        <div className={`board_strength_cards_holder ${strengthContainerOpenCloseAnimation}`} style={{zIndex: getZIndexStrengthCardsHolder()}}>

            <div className="left_linear_gradient_line_wrapper">
                <div className="linear_gradient_line" style={{height: "70vh"}} />
            </div>

            <div className={`full_screen ${strengthCardsAnimationDuringAvatarRotationStyle} `}>
                <div className="strength_cards_holder" >

                    <div className={`strength_cards_holder__row ${instructionTutorial === "leftSideOfTheScreen" && "right_side_screeen_instructions_background"} `}>
                        <RenderStrengthCardType />
                    </div>
                    <div className="linear_gradient_line_wrapper" style={{ position: 'absolute', left: '100%', flexDirection: 'row' }}>
                        <div className="linear_gradient_line" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StrengthCardsHolder;

